import { gql } from 'apollo-angular';

export const QUEUE_CASE_PARTS = gql`
  fragment QueueCaseParts on ApplicationCaseType {
    id
    currentQueue {
      id
      displayName
    }
    queueassociationSet(includeArchived: true) {
      created
      deleted
      applicationQueue {
        id
        displayName
        shortName
      }
    }
  }
`;

export const QUEUES_QUERY = gql`
  query Queues($myAssigned: Boolean) {
    queues(myAssigned: $myAssigned) {
      id
      adminName
      displayName
      appCasesCount
    }
  }
`;

export const QUEUE_QUERY = gql`
  query Queue($queueId: ID, $page: Int, $sortDir: String, $sortCol: String, $pageSize: Int, $assignmentFilter: String) {
    queue(queueId: $queueId) {
      id
      adminName
      shortName
      pagedQueueAssociations(page: $page, sortDir: $sortDir, sortCol: $sortCol, pageSize: $pageSize) {
        page
        total
        hasNext
        hasPrev
        numPages
        queueAssociations {
          id
          created
          applicationCase {
            caseRoleAssignments(assignmentFilter: $assignmentFilter) {
              assigneeType {
                adminName
              }
              user {
                firstName
                lastName
              }
            }
            id
            created
            caseStatus
            application {
              id
              applicationType {
                id
                name
              }
            }
            applicant {
              id
              fullName
              emailuser {
                id
                email
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`;

export const ALL_QUEUES_QUERY = gql`
  query allQueues($caseId: UUID!) {
    case(id: $caseId) {
      ...QueueCaseParts
    }
  }
  ${QUEUE_CASE_PARTS}
`;

export const MOVE_TO_QUEUE_MUTATION = gql`
  mutation MoveToQueue($applicationCase: UUID!, $queueId: ID!, $removeOthers: Boolean) {
    moveToQueue(applicationCase: $applicationCase, queueId: $queueId, removeOthers: $removeOthers) {
      case {
        ...QueueCaseParts
      }
    }
  }
  ${QUEUE_CASE_PARTS}
`;

export const REMOVE_FROM_QUEUE_MUTATION = gql`
  mutation RemoveFromQueue($appQueueId: ID!, $caseId: UUID!) {
    removeFromQueue(appQueueId: $appQueueId, caseId: $caseId) {
      case {
        ...QueueCaseParts
      }
    }
  }
  ${QUEUE_CASE_PARTS}
`;
